module.exports = __webpack_public_path__ + "img/HY1702-177.e9fa6c49.jpg";